module.exports = __webpack_public_path__ + "img/mac-mini.54bb267b.svg";